import React, { useContext } from 'react';
import { centsToDollars } from '../../utils';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid';
import { CheckoutContext } from '../../Providers/CheckoutContext';

type Props = {
  title: string;
  price: number;
  onClick: () => void;
  editable?: boolean;
  modsChecked: boolean;
  handleExternal?: boolean;
};

const AddToCartBanner: React.FC<Props> = ({
  onClick,
  title,
  price,
  editable = false,
  modsChecked,
  handleExternal = false,
}) => {
  const currentCheckout = useContext(CheckoutContext);
  return (
    <>
      {
        <div
          className="w-full bg-surface fixed bottom-0 md:-mx-8 lg:-mx-16 xl:-mx-32 group hover:cursor-pointer"
          onClick={onClick}
        >
          <div
            className={`flex flex-row p-4 md:mx-8 lg:mx-16 xl:mx-32 ${
              modsChecked
                ? !editable
                  ? 'bg-primary'
                  : 'bg-primary'
                : 'bg-primary/10'
            } items-center justify-center shadow-sm rounded-t-md`}
          >
            <div className="flex flex-col leading-normal">
              <div className="flex items-center">
                <span
                  className={`${
                    !editable
                      ? 'text-on-primary text-center'
                      : 'text-on-primary text-left'
                  } font-bold text-lg  mx-auto`}
                >
                  {currentCheckout?.add_item_btn_title ?? title}
                </span>
                {handleExternal ? (
                  <ArrowTopRightOnSquareIcon className="w-4 h-4 text-on-primary ml-1" />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default AddToCartBanner;
